module.exports = __webpack_public_path__ + "static/media/logo.30a4bc61.png";